import { useTranslation } from 'react-i18next'
import { useFormikContext } from 'formik'

import {
  BuildingMultiSelect,
  BuildingSelectFormikField,
} from '../../../../Building'
import { FieldStackedLabel } from '../../../../Field'
import { FormFieldsContainer } from '../../../../Form'
import {
  FormikEntityActionConfigFields,
  useFormikEntityActionConfigFieldsClearFields,
} from '../../../../Formik'
import {
  ENTITY_TAB_BUILDINGS_EDIT_MODAL_EMPTY_VALUES,
  ENTITY_TAB_BUILDINGS_EDIT_MODAL_FIELD_NAME_BUILDINGS,
} from '../EntityTabBuildingsEditModal.constants'

function FormFields({ actionTypes, isLoading }) {
  const { t } = useTranslation()

  const { errors } = useFormikContext()

  const { actionTypeValueIsRemoveAll } =
    useFormikEntityActionConfigFieldsClearFields({
      emptyValues: ENTITY_TAB_BUILDINGS_EDIT_MODAL_EMPTY_VALUES,
    })

  return (
    <FormFieldsContainer>
      <FormikEntityActionConfigFields
        typeSelectProps={{
          error: errors[ENTITY_TAB_BUILDINGS_EDIT_MODAL_FIELD_NAME_BUILDINGS],
          options: actionTypes,
        }}
      >
        <BuildingSelectFormikField
          multi
          Field={FieldStackedLabel}
          Select={BuildingMultiSelect}
          controlProps={{
            contentProps: {
              inputProps: {
                autoFocus: true,
                placeholder: t('Building.BuildingsFieldPlaceholderKey'),
              },
            },
          }}
          disabled={actionTypeValueIsRemoveAll}
          fieldComponentProps={{
            isLoading,
            label: `${t('Building.BuildingsFieldLabelKey')}:`,
          }}
          name={ENTITY_TAB_BUILDINGS_EDIT_MODAL_FIELD_NAME_BUILDINGS}
        />
      </FormikEntityActionConfigFields>
    </FormFieldsContainer>
  )
}

export default FormFields
